// Renviro's canonical industry vocabulary. Sourced from sales feedback so
// reports group cleanly and reps don't type ten variants of the same name.
// Keep this file in sync with the backend `INDUSTRY_OPTIONS` if you wire
// server-side validation later.
export const INDUSTRY_OPTIONS = [
  "Aerospace & Defense",
  "Agriculture & Farming",
  "Automotive Manufacturing",
  "Automotive Parts & Components",
  "Battery & EV Industries",
  "Cement & Concrete",
  "Chemical Manufacturing",
  "Construction & Infrastructure",
  "Distributors & Channel Partners",
  "Electronics Manufacturing",
  "Energy & Utilities",
  "Facilities Management & Building Management",
  "Food & Beverages Manufacturing",
  "Glass Manufacturing",
  "HVAC, Refrigeration & Equipment Manufacturing",
  "Industrial Services",
  "Industrial Services & Infrastructure",
  "Logistics & Warehousing",
  "Metal Fabrication",
  "Mining",
  "Mining & Equipment Manufacturing",
  "Oil & Gas",
  "Oil & Refineries",
  "Paper & Packaging",
  "Pharmaceutical Industry",
  "Port Industry",
  "Power Generation",
  "Power Transmission & Distribution",
  "Renewable Industry",
  "Steel & Metal Processing",
  "Steel Fabrication",
  "Textile & Apparel Manufacturing",
  "Utilities (Water, Electric, Gas)",
  "Waste Management",
  "Water & Wastewater Treatment",
];
